document.addEventListener("DOMContentLoaded", () => {
  const $ = window.jQuery;

  if (!$ || !$.fn.slick) {
    console.error("Slick or jQuery not loaded");
    return;
  }

  const $carousels = $(".js-social-impact-carousel");

  $carousels.each(function () {
    const $carousel = $(this);

    if ($carousel.hasClass("slick-initialized")) return;

    $carousel.slick({
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      arrows: false,
      centerMode: true,
      centerPadding: "0px",
      autoplaySpeed: 8000,
      responsive: [
        {
          breakpoint: 1244,
          settings: {
            slidesToShow: 2,
            centerMode: false
          }
        }
      ]
    });
  });
});